import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ICancelExtractCreationParams extends IMultipleIdsParams {
  contentType: string;
}

export class CancelExtractCreationRequest extends Request<ICancelExtractCreationParams, IResult> {
  constructor(contentIds: string[], contentType: string) {
    super('cancelExtractCreation', {
      ids: contentIds,
      contentType: contentType
    });
  }
}
